import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";

import "react-toastify/dist/ReactToastify.css";
import "./Contact.scss";
import { Button } from "./Button";

toast.configure();
const notify = () => {
  toast("Basic notification!");
};

function Contact({ setIsMapsActive }) {
  const height = window.innerHeight;
  const width = window.innerWidth;

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 960px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 960px)" });

  function sendEmail(e) {
    e.preventDefault();
    const arrFields = [];

    if (document.getElementById("txtHp").value == "") {
      if (document.getElementById("txtName").value == "") {
        arrFields.push("name");
      }

      if (document.getElementById("txtCompName").value == "") {
        arrFields.push("company name");
      }

      if (document.getElementById("txtPhone").value == "") {
        arrFields.push("phone number");
      }

      if (document.getElementById("txtEmail").value == "") {
        arrFields.push("e-mail address");
      }

      if (document.getElementById("txtMessage").value == "") {
        arrFields.push("message");
      }

      console.log(arrFields);

      if (arrFields.length > 0) {
        toast.warning(`Please fill out all fields.`, {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        toast.success("Success! Your message has been sent.", {
          position: toast.POSITION.TOP_CENTER,
        });
        emailjs
          .sendForm(
            "service_cj24p2i",
            "template_0fy98bn",
            e.target,
            "vCxhkim-5LyxYY_BN"
          )
          .then(
            (result) => {
              console.log(result.text);
            },
            (error) => {
              console.log(error.text);
            }
          );
        e.target.reset();
      }
    } else {
      return;
    }
  }

  const [showConsent, setShowConsent] = useState(false);
  const [hasAgreed, setHasAgreed] = useState(false);
  const [showDataPrivacyAct, setShowDataPrivacyAct] = useState(false);

  const handleCheckboxChange = (e) => {
    setHasAgreed(e.target.checked);
    setTimeout(() => {
      handleClickViewConsent();
    }, 600);
  };

  const handleClickViewConsent = () => {
    setShowConsent((prevState) => !prevState);
  };

  const handleClickConsentContent = (e) => {
    e.stopPropagation();
  };

  const handleClickViewDPP = () => {
    setShowDataPrivacyAct((prevState) => !prevState);
  };

  return (
    <>
      {showConsent && (
        <div className="modal-consent" onClick={handleClickViewConsent}>
          <div className="consent-content" onClick={handleClickConsentContent}>
            <div className="consent-content-inner">
              <div className="consent-content-head">
                Data Privacy Consent Statement
              </div>
              <div className="consent-content-body">
                <p className="consent-content-p">
                  By submitting this form, you agree and consent to the
                  collection, use, and processing of the personal information
                  you provide, including your name, email address, contact
                  number, and message content.
                </p>
                <p className="consent-content-p">
                  This information will be used solely for the purpose of
                  responding to your inquiry, providing support, or addressing
                  any request you may have. We will not share your data with
                  third parties.
                </p>
                <p className="consent-content-p">
                  All personal data collected through this form will be handled
                  in accordance with applicable data privacy laws. You may
                  contact us at any time to request access to your data or to
                  withdraw your consent.
                </p>
              </div>
            </div>
            <div className="consent-content-footer">
              <div>
                <label htmlFor="check-consent" className="checkbox">
                  <input
                    type="checkbox"
                    id="check-consent"
                    checked={hasAgreed}
                    onChange={handleCheckboxChange}
                  />
                  I have read and agree to the Data Privacy Consent Statement.
                </label>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDataPrivacyAct && (
        <div className="modal-dpp" onClick={handleClickViewDPP}>
          <div className="dpp-content" onClick={handleClickConsentContent}>
            <div className="dpp-scroller">
              <div className="dpp-header">
                <h3>Privacy Policy</h3>
                <h4>
                  In compliance with the Philippine Data Privacy Act of 2012 (RA
                  10173)
                </h4>
              </div>
              <br />
              <p className="dpp-effective-date">
                Effective Date: February 1, 2020
                <br />
                <br />
                We value your privacy and are committed to protecting your
                personal data. This Privacy Policy outlines how we collect, use,
                and protect the information you provide through our website,
                specifically via the “Contact Us” form.
              </p>
              <br />
              <div className="dpp-items">
                <div className="dpp-item">
                  <h5>1. Information We Collect</h5>
                  <p>
                    When you submit an inquiry through the Contact Us page, we
                    may collect the following personal information:
                  </p>
                  <ul>
                    <li>• Full Name</li>
                    <li>• Email Address</li>
                    <li>• Contact Number (if provided)</li>
                    <li>
                      • Any other information you choose to include in your
                      message
                    </li>
                  </ul>
                </div>
                <div className="dpp-item">
                  <h5>2. Purpose of Collection</h5>
                  <p>
                    We collect your personal data for the following purposes:
                  </p>
                  <ul>
                    <li>• To respond to your inquiries or requests</li>
                    <li>
                      • To provide customer support or follow-up information
                    </li>
                    <li>
                      • For documentation and administrative purposes related to
                      your inquiry
                    </li>
                  </ul>
                </div>
                <div className="dpp-item">
                  <h5>3. Lawful Basis for Processing</h5>
                  <p>
                    Your data is processed under the following lawful bases:
                  </p>
                  <ul>
                    <li>
                      • Legitimate Interest: We have a legitimate interest in
                      responding to inquiries submitted via our website.
                    </li>
                    <li>
                      • Consent: By submitting the form, you are providing
                      consent for us to process your personal data for the
                      stated purposes.
                    </li>
                  </ul>
                </div>
                <div className="dpp-item">
                  <h5>4. Data Sharing and Disclosure</h5>
                  <p>
                    We do not sell or share your personal information with third
                    parties. However, we may disclose your data if:
                  </p>
                  <ul>
                    <li>• Required by law or legal process</li>
                    <li>
                      • Necessary to protect our rights or comply with a
                      judicial proceeding
                    </li>
                  </ul>
                </div>
                <div className="dpp-item">
                  <h5>5. Data Retention</h5>
                  <p>
                    Your information will be retained only for as long as
                    necessary to fulfill the purposes outlined above or as
                    required by applicable laws and regulations.
                    <br />
                    <br />
                    We implement appropriate technical and organizational
                    measures to safeguard your personal data against
                    unauthorized access, alteration, or disclosure.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isDesktopOrLaptop && (
        <div
          id="contact-email-form"
          className="contact"
          style={{ height: height / 1.6, position: "relative" }}
        >
          <div className="contact__col">
            <div className="contact__row-header">
              Got questions? We'd love to hear them from you!
            </div>
            <div className="contact__row-header">
              Email us at{" "}
              <span style={{ color: "var(--primary)" }}>consulting</span>
              @toplogic.com.ph
            </div>
            <div className="contact__row-details">
              <div className="details__col col-1">
                <ul className="address">
                  <li className="address-line">
                    9th Floor, One Griffinstone Building, Commerce Avenue,
                    corner Spectrum Midway, Filinvest Corporate City, Alabang,
                    Muntinlupa
                  </li>
                  <li
                    className="address-line link"
                    onClick={() => {
                      setIsMapsActive(true);
                    }}
                  >
                    See in Google Maps
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className="contact__col"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <form id="contactForm" method="POST" onSubmit={sendEmail}>
              <input
                id="txtHp"
                style={{
                  display: "none",
                  pointerEvents: "none",
                  cursor: "none",
                }}
              ></input>
              <input
                className="toplogic-input"
                placeholder="Name"
                id="txtName"
                name="name"
              />
              <input
                className="toplogic-input"
                placeholder="Company Name"
                id="txtCompName"
                name="companyname"
              />
              <input
                className="toplogic-input inputmask-num"
                placeholder="Phone"
                id="txtPhone"
                name="phone"
              />
              <input
                className="toplogic-input"
                placeholder="E-mail Address"
                id="txtEmail"
                name="email"
              />
              <textarea
                className="toplogic-input full-width thin-scroll"
                placeholder="Message"
                id="txtMessage"
                name="message"
              ></textarea>

              <div className="form-footer">
                <div className="view-consent">
                  <div
                    className="view-consent-btn"
                    onClick={handleClickViewConsent}
                  >
                    Read and Agree to the Data Privacy Consent Statement
                  </div>
                </div>

                <div>
                  <Button
                    id="btnSubmit"
                    children="Submit"
                    fontColor="white"
                    className="btn--gradient btn--mobile btn--wide"
                    buttonWidth="100%"
                    disabled={!hasAgreed}
                    isVisible={isDesktopOrLaptop}
                  />
                </div>

                <div className="view-dpp">
                  <div className="view-dpp-btn" onClick={handleClickViewDPP}>
                    View Data Privacy Policy
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {isTabletOrMobile && (
        <div
          className="contact"
          style={{ height: "90%", position: "relative" }}
        >
          <div className="contact__col">
            <div className="contact__row-header">
              Got questions? We'd love to hear them from you!
            </div>
            <div className="contact__row-desc">
              Please fill out the form below to stay tuned.
            </div>
          </div>
          <div className="contact__col">
            <form id="contactForm" method="POST" onSubmit={sendEmail}>
              <input
                id="txtHp"
                style={{
                  display: "none",
                  pointerEvents: "none",
                  cursor: "none",
                }}
              ></input>
              <input
                className="toplogic-input"
                placeholder="Name"
                id="txtName"
                name="name"
              />
              <input
                className="toplogic-input"
                placeholder="Company Name"
                id="txtCompName"
                name="companyname"
              />
              <input
                className="toplogic-input inputmask-num"
                placeholder="Phone"
                id="txtPhone"
                name="phone"
              />
              <input
                className="toplogic-input"
                placeholder="E-mail Address"
                id="txtEmail"
                name="email"
              />
              <textarea
                className="toplogic-input full-width thin-scroll"
                placeholder="Message"
                id="txtMessage"
                name="message"
              ></textarea>

              <div className="view-consent">
                <div
                  className="view-consent-btn"
                  onClick={handleClickViewConsent}
                >
                  View Data Privacy Consent Statement
                </div>
              </div>

              <Button
                id="btnSubmit"
                children="Submit"
                fontColor="white"
                className="btn--gradient btn--mobile btn--wide"
                buttonWidth="100%"
                isVisible={isTabletOrMobile}
              />
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default Contact;
